import React from 'react';
import { Tabs, message, Radio, Button, InputNumber, Modal } from 'antd'; // dialog UI}
import { DeleteOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
const { TabPane } = Tabs;
const PublicAppointmentHomepage = ({
  setOpenTimeDialog,
  openTimeDialog,
  setDayAllowTime,
  openTimeIndex,
  openTimeStatus,
  setOpenTimeStatus,
  setOpenTime,
  setOpenTimeIndex,
  openTime,
}) => {
  const week = ['一', '二', '三', '四', '五', '六', '日'];
  return (
    <>
      {/* 選擇開放時間星期 */}
      <Modal
        width={600}
        overflowScroll
        hasMask
        className={styles.openTimeDialog}
        visible={openTimeDialog}
        onCancel={() => {
          setOpenTimeDialog(false);
        }}
        onClose={() => {
          setOpenTimeDialog(false);
        }}
        onOk={() => {
          setOpenTimeDialog(false);
          const newOpenTime = JSON.parse(JSON.stringify(openTime));
          setDayAllowTime(newOpenTime);
        }}
      >
        <h3>設定開放時間</h3>
        <Tabs
          activeKey={openTimeIndex.toString()}
          onChange={(value) => setOpenTimeIndex(value)}
        >
          {openTime.map((item, index) => (
            <TabPane tab={`星期${week[index]}`} key={index.toString()}>
              <Radio.Group
                value={openTimeStatus[index]}
                onChange={(e) => {
                  const temp = [...openTimeStatus];

                  temp[index] = e.target.value;
                  setOpenTimeStatus(temp);
                  const newOpenTime = [...openTime];
                  if (e.target.value === 'all') {
                    newOpenTime[index] = [[0, 24]];
                  } else if (e.target.value === 'no') {
                    newOpenTime[index] = [];
                    setOpenTime(newOpenTime);
                  } else if (e.target.value === 'yes') {
                    newOpenTime[index] = [[0, 23]];
                  }
                  setOpenTime(newOpenTime);
                }}
              >
                <Radio value="yes">開放</Radio>
                <Radio value="all">開放24小時</Radio>
                <Radio value="no">非開放</Radio>
              </Radio.Group>

              {openTimeStatus[index] === 'yes' && (
                <>
                  <div style={{ marginTop: 10 }}>
                    <Button
                      onClick={() => {
                        const temp = [...openTime];
                        temp[index].push([0, 23]);
                        setOpenTime(temp);
                      }}
                    >
                      新增開放時間
                    </Button>
                  </div>
                  {openTime[index].length > 0 && (
                    <div className={styles.endTimeText}>
                      時間為24小時制，請輸入0-24的數字
                    </div>
                  )}

                  {openTime[index].map((openTimeItem, index2) => (
                    <div className={styles.openTimeItem} key={index2}>
                      <div>
                        開始時間:
                        <InputNumber
                          max={24}
                          min={0}
                          value={openTimeItem[0]}
                          innerAfter="：00"
                          onChange={(value) => {
                            const temp = [...openTime];
                            temp[index][index2][0] = value;
                            setOpenTime(temp);
                            if (value > openTimeItem[1]) {
                              message.error('開始時間不可大於結束時間');
                            }
                          }}
                        />
                      </div>
                      <div style={{ paddingLeft: 10 }}>
                        結束時間:
                        <InputNumber
                          max={24}
                          min={0}
                          value={openTimeItem[1]}
                          innerAfter="：00"
                          onChange={(value) => {
                            const temp = [...openTime];
                            temp[index][index2][1] = value;
                            setOpenTime(temp);
                            if (value < openTimeItem[0]) {
                              message.error('結束時間不可小於開始時間');
                            }
                          }}
                        />
                      </div>
                      <div style={{ paddingLeft: 20 }}>
                        <DeleteOutlined
                          onClick={() => {
                            const temp = [...openTime];
                            temp[index].splice(index2, 1);
                            setOpenTime(temp);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </>
              )}
            </TabPane>
          ))}
        </Tabs>
      </Modal>
    </>
  );
};
export default PublicAppointmentHomepage;
